import { APIcallerv2 } from './APIcaller';

const getLocationsOfAccount = (accountId) => APIcallerv2.apiGet(`/accounts/${accountId}/locations`);

const getAccountNotifications = (accountId) =>
  APIcallerv2.apiGet(`/accounts/${accountId}/notifications`);

export default { getLocationsOfAccount, getAccountNotifications };
